import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-black mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-black`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "Polityka cookies" }) => {
  return (
    <AnimationRevealPage>
      <Header />
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>Ostatnia akutalizacja: 05 grudzień 2025 r.</p>

            <h2>1. Informacje ogólne</h2>
            <p>
            Niniejsza Polityka cookies dotyczy plików cookies oraz podobnych technologii wykorzystywanych w Serwisie internetowym www.e-cenowki.pl, którego administratorem jest dataGRIT Sp. z o.o. z siedzibą w 05-830 Nadarzyn, ul. Plantowa 5/6.
            </p>

            <h2>2. Czym są pliki cookies?</h2>
            <p>
            Pliki cookies to niewielkie pliki tekstowe zapisywane na urządzeniu Użytkownika (komputerze, smartfonie, tablecie) podczas korzystania z Serwisu. Cookies umożliwiają m.in. prawidłowe działanie strony, dostosowanie jej funkcji do preferencji Użytkownika oraz analizę korzystania z Serwisu.
            </p>

            <h2>3. Jakie pliki cookies wykorzystujemy?.</h2>
            <p>
            W Serwisie mogą być stosowane następujące rodzaje plików cookies:<br></br><br></br>
            a) Cookies niezbędne (techniczne) - umożliwiają korzystanie z podstawowych funkcji Serwisu, takich jak:
            <ul>
              <li>nawigacja,</li>
              <li>poprawne wyświetlanie treści,</li>
              <li>obsługa formularzy.</li>
            </ul>
            Bez tych plików strona nie może działać prawidłowo.<br></br><br></br>
            b) Cookies analityczne/statystyczne - Pozwalają zbierać anonimowe dane statystyczne dotyczące sposobu korzystania z Serwisu, co umożliwia ulepszanie jego funkcjonalności. Mogą pochodzić np. z:
            <ul>
              <li>Google Analytics,</li>
              <li>narzędzi analizy ruchu na stronie.</li>
            </ul><b></b><br></br>
            c) Cookies funkcjonalne - umożliwiają zapamiętanie preferencji Użytkownika, takich jak:
            <ul>
              <li>wybrany język,</li>
              <li>ustawienia wyświetlania,</li>
              <li>zapamiętanie danych formularzy.</li>
            </ul><br></br>
            c) Cookies marketingowe (opcjonalne) - umożliwiają wyświetlanie spersonalizowanych reklam lub mierzenie ich skuteczności. Mogą pochodzić z zewnętrznych systemów reklamowych (np. Google Ads, Meta Ads). Pliki te stosowane są wyłącznie po wyrażeniu zgody przez Użytkownika.
            <br></br>
            </p>

            <h2>4. Podstawa prawna przetwarzania danych z plików cookies</h2>
            <p>
            <ul>
              <li>Dla cookies niezbędnych – art. 6 ust. 1 lit. f RODO (prawnie uzasadniony interes Administratora: prawidłowe funkcjonowanie strony).</li>
              <li>Dla cookies analitycznych, funkcjonalnych i marketingowych – zgoda Użytkownika (art. 6 ust. 1 lit. a RODO).</li>
            </ul>
            Zgodę można wycofać w dowolnym momencie.
            </p>

            <h2>5. Zarządzanie plikami cookies</h2>
            <p>
            Użytkownik może w każdej chwili:
            <ul>
              <li>zaakceptować wszystkie cookies,</li>
              <li>odrzucić wszystkie poza niezbędnymi,</li>
              <li>zmienić ustawienia w przeglądarce.</li>
            </ul>
            Jak wyłączyć cookies w przeglądarce?<br></br>
            Instrukcje dostępne są na stronach producentów przeglądarek:
            <ul>
              <li>Chrome,</li>
              <li>Firefox,</li>
              <li>Safari,</li>
              <li>Edge,</li>
              <li>Opera.</li>
            </ul>
            Wyłączenie cookies technicznych może spowodować nieprawidłowe działanie Serwisu.
            </p>

            <h2>6. Pliki cookies podmiotów trzecich</h2>
            <p>
            W Serwisie mogą być używane cookies pochodzące od zewnętrznych dostawców, takich jak:
            <ul>
              <li>Google LLC (Google Analytics, Google Ads),</li>
              <li>Meta Platforms Inc. (Facebook Pixel),</li>
              <li>narzędzia statystyczne lub marketingowe partnerów technologicznych.</li>
            </ul>
            Podmioty te mogą umieszczać na urządzeniu Użytkownika swoje pliki cookies i przetwarzać dane zgodnie z własnymi politykami prywatności.
            </p>

            <h2>Okres przechowywania plików cookies</h2>
            <p>
            Pliki cookies mogą być przechowywane:
            <ul>
              <li>sesyjnie (do zamknięcia przeglądarki),</li>
              <li>stałe (pozostają na urządzeniu przez określony czas lub do ręcznego usunięcia).</li>
            </ul>
            </p>

            <h2>8. Jakie dane mogą być zbierane za pomocą cookies?</h2>
            <p>
            Cookies mogą gromadzić m.in.:
            <ul>
              <li>adres IP (zazwyczaj anonimizowany),</li>
              <li>dane przeglądarki,</li>
              <li>rodzaj urządzenia,</li>
              <li>aktywność w Serwisie,</li>
              <li>kliknięcia, czas przebywania, podstrony odwiedzane w Serwisie.</li>
            </ul>
            Dane te są z reguły anonimizowane i nie pozwalają na bezpośrednią identyfikację Użytkownika bez dodatkowych informacji.
            </p>

            <h2>9. Zmiany w Polityce cookies</h2>
            <p>
            Administrator zastrzega sobie możliwość wprowadzania zmian w niniejszej Polityce cookies w związku z:
            <ul>
              <li>rozwojem technologii,</li>
              <li>zmianami prawa,</li>
              <li>wdrażaniem nowych funkcjonalności Serwisu.</li>
            </ul>
            O zmianach będziemy informować w sposób jasny i widoczny.
            </p>
            
            <h2>10. Kontakt</h2>
            <p>
            W przypadku pytań dotyczących cookies lub ochrony danych osobowych prosimy o kontakt: dataGRIT Sp. z o.o. ul. Plantowa 5/6, 05-830 Nadarzyn e-mail: kontakt@datagrit.pl
            </p>
          </Text>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  );
};
